import React from 'react';
import '../NotFound/NotFound.css';

const NotFound = () => {
  const handleGoHome = () => {
 
    window.location.href = '/';
  };

  const handleContact = () => {
   window.location.href = '/contactus';
  };

  return (
    <div className="not-found-container-nf">
      {/* Animated background elements */}
      <div className="bg-animation-nf">
        <div className="bg-circle-nf"></div>
        <div className="bg-circle-nf"></div>
        <div className="bg-circle-nf"></div>
        <div className="bg-circle-nf"></div>
        <div className="bg-circle-nf"></div>
      </div>
      
      <div className="not-found-content-nf">
        <h1 className="error-code-nf">404</h1>
        <h2 className="error-message-nf">Page Not Found</h2>
        
        <div className="progress-container-nf">
          <div className="progress-bar-nf"></div>
        </div>
        
        <h3 className="coming-soon-nf">Coming Soon...</h3>
        
        <p className="error-description-nf">
          The page you are looking for doesn't exist or has been moved. 
          We're working hard to bring you amazing content. Please check back soon!
        </p>
        
        <div className="action-buttons-nf">
          <button className="action-button-nf home-button-nf" onClick={handleGoHome}>
            Go to Homepage
          </button>
          <button className="action-button-nf contact-button-nf" onClick={handleContact}>
            Contact Support
          </button>
        </div>
        
      
      </div>
    </div>
  );
};

export default NotFound;